var VideoCameraEditModal = (function (base) {
  __extends(VideoCameraEditModal, base);


  function VideoCameraEditModal(apiClient) {
    const self = base.call(this, apiClient) || this;
    return self;
  };


  VideoCameraEditModal.prototype.activate = function (vcameraId) {
    const self = this;
    const isNew = !vcameraId;
    const url = isNew ? `api/videoCameras/add` : `api/videoCameras/${vcameraId}/edit`;

    this.loadContent(url)
      .then($modal => {

        var $form = $('form', $modal);
        FormHelper.init($form, isNew ? 'PUT' : 'POST', 'api/videoCameras');

        coordinates.reloadRoadCoordinates().then(function () {
          coordinates.updateCoordinates({ isPoint: true });
        });

        $modal

          //Кнопка `Сохранить`
          .on('click', '[js=save]', function () {
            $modal.busy();
            $form.send()
              .then(() => self.close({ ok: true }))
              .catch(() => $modal.busy(false));
          })

          //Выбор кода автодороги
            .on('change', '#RoadId', () => {
            coordinates.reloadRoadCoordinates()
              .then(() => {
                coordinates.updateCoordinates({ isPoint: true });
              });
          })

          //Изменение километра МС на дороге
          .on('change', '#Location', () => {
            coordinates.updateCoordinates({ isPoint: true });
          })

          //Кнопка `Задать координату на карте`
          .on('click', '[js=edit-coordinate]', () => {

            const vcameraName = $('#Name', $modal).val();
            const roadId = parseInt($('#RoadId option:selected', $modal).val());
            const location = parseFloat($('#Location', $modal).val());
            const roadStartKm = coordinates.getRoadStartKm(roadId);

              ModalConductor.activate(VideoCameraMapModal, vcameraId, roadId, vcameraName, roadStartKm, location)
              .on('closed',
                modalResult => {
                  if (modalResult.ok) {
                    $('#Location', $modal).val(modalResult.location);
                    $('#Lat', $modal).val(modalResult.coordinate.lat);
                    $('#Lng', $modal).val(modalResult.coordinate.lng);
                  }
                });
          });
      });
  };


  return VideoCameraEditModal;
}(BaseModal));
